import { AfterContentInit, Component, ContentChild, ContentChildren, Directive, EventEmitter, Input, Output, QueryList } from "@angular/core";
import { DeloitteAiCardActionDirective } from "./card-action";

interface Product {
  id: string;
  product_id: string;
  name: string;
  short_description: string;
  icon_url: string;
  tags: Array<string>;
}

@Directive({
    selector: "[deloitteaiProductCardIcon]"
})
export class DeloitteAiProductCardIconDirective { }

@Component({
    selector: "deloitteai-product-card",
    templateUrl: "./product-card.html",
    styleUrls: ["./product-card.scss"]
})
export class DeloitteAiProductCardComponent implements AfterContentInit {

    @Input()
    public product: Product;

    @Output()
    public showDetails: EventEmitter<Product>;

    @ContentChildren(DeloitteAiProductCardIconDirective, {read: DeloitteAiProductCardIconDirective, descendants: true})
    private icon: QueryList<DeloitteAiProductCardIconDirective>;

    @ContentChild(DeloitteAiCardActionDirective)
    public actionTrigger: DeloitteAiCardActionDirective;

    public hasCustomIcon = false;

    public hasCuustomTrigger = false;

    public constructor() {
        this.showDetails = new EventEmitter();
    }

    public handleClick($event: MouseEvent): void {
        $event.preventDefault();
        $event.stopPropagation();

        this.showDetails.emit(this.product);
    }

    public ngAfterContentInit(): void {
        this.icon.changes.subscribe((items: QueryList<DeloitteAiProductCardIconDirective>) => {
            this.hasCustomIcon = items.length >= 1;
        });
    }
}
